import Vue from "vue";
import VueI18n from "vue-i18n";

import English from "./english";
import Spanish from "./spanish";


Vue.use(VueI18n);

export default new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: English,
        sp: Spanish
    }
});